<template>
    <div style="margin-top:10px;">
        <div class="vld-parent">
            <loading v-model:active="isLoading"
                     :loader="'bars'"
                     :height="80"
                     :width="80"
                     :background-color="'#fff'"
                     :opacity="0.8"
                     :blur="'2px'"
                     :color="'#ff51b8'"
                     :lock-scroll="true"
                     :can-cancel="false"
                     :is-full-page="true" />

            <form v-if="!showDashboard">
                <input type="hidden" name="SessionID" value="" />
                <img id="hiddenImage" name="hiddenImage" :src="carrierUrl" style="visibility:hidden">

                <div class="wrapper">
                    <!-- Mobile-visible logo at top center -->
                    <div class="mobile-logo-container">
                        <img :src="normalizedLogoUrl" alt="Dealership Logo" class="img-fluid" style="max-height: 80px; max-width: 200px; display: inline-block;">
                    </div>

                    <div class="left-panel">

                        <div class="video-area">
                            <div class="video-block">
                                <!--<div class="video-img">
                                    <img src="../assets/video-desktop2@2x.png" alt="img" class="img-fluid">
                                </div>-->
                                <video id="helpVideoPlayerMain" class="video" style="width:100%; height:100%;" controls>
                                    <source src="../assets/cd-helper.mp4" type="video/mp4">
                                </video>
                                <div v-show="!isPlayingMainVideo" class="video-play">
                                    <a @click.prevent="playHelpVideoMain" href="#" data-toggle="modal" data-target="#videoModal"><img src="../assets/video-play-button.svg" alt="img" class="img-fluid"></a>
                                </div>
                            </div>
                        </div>

                        <div class="features-area">
                            <div class="features-block">
                                <h3 style="margin-top:0px;margin-bottom:50px;">Quick, secure pre-qualification</h3>
                                <ul>
                                    <li><strong>Backed by </strong><img src="../assets/1280px-Equifax_Logo.svg.png" alt="img" class="img-fluid img-equifax-small-inline"></li>
                                    <li><strong>Soft Inquiry</strong> means no impact to your credit.</li>
                                    <li><strong>Pre-Qualified</strong> in seconds.</li>
                                    <li><strong>Free</strong> credit score.</li>
                                </ul>
                            </div>
                        </div>

                    </div>

                    <div class="right-panel">

                        <div class="form-area">

                            <div v-show="visibleRightTab == 'showSubmitPhoneAndName'">

                                <div class="form-top">
                                    <div class="form-lang">
                                    </div>
                                    <div class="form-close">
                                        <p>Get pre-qualified <strong>in seconds</strong></p>
                                    </div>
                                    <div class="form-logo">
                                        <img :src="urlToLogo" alt="img" class="img-fluid" style="max-height: 90px;">
                                    </div>
                                </div>


                                <div class="video-area">
                                    <div class="video-block">
                                        <div class="video-img">
                                            <img src="../assets/video-thumbnail2@2x.png" alt="img" class="img-fluid">
                                        </div>
                                        <div class="video-play">
                                            <a @click.prevent="playModalHelpVideo" href="#" data-toggle="modal" data-target="#videoModal"><img src="../assets/video-play-button.svg" alt="img" class="img-fluid"></a>
                                        </div>
                                    </div>
                                </div>


                                <div class="main-form">
                                    <div class="form-head">
                                        <h1><strong>See how much you're prequalified for and get your</strong> free FICO&reg; score.</h1>
                                    </div>

                                    <div class="form-block">
                                        <div class="form-row">
                                            <div class="form-group col-12" v-bind:class="{ 'valid-group': isSubmittedPhoneNumberValid }">
                                                <label v-bind:class="{ pushed: showPushedSubmittedPhoneNumberLabel }" @click="isSubmittedPhoneNumberBeingEntered = true; this.$refs.refSubmittedPhoneNumber.focus();">Cell Phone Number</label>
                                                <input v-model="submittedPhoneNumber" v-mask="'###-###-####'" ref="refSubmittedPhoneNumber" @focus="isSubmittedPhoneNumberBeingEntered = true" @blur="isSubmittedPhoneNumberBeingEntered = false" type="tel" name="phone" id="phoneField" class="form-control" required>
                                            </div>
                                        </div>
                                        <div v-if="isSubmittedPhoneNumberValid" class="form-row">
                                            <div class="form-group col-12" v-bind:class="{ 'valid-group': isSubmittedFirstNameValid }">
                                                <label v-bind:class="{ pushed: showPushedSubmittedFirstNameLabel }" @click="isSubmittedFirstNameBeingEntered = true; this.$refs.refSubmittedFirstName.focus();">First Name</label>
                                                <input v-model="submittedFirstName" ref="refSubmittedFirstName" @focus="isSubmittedFirstNameBeingEntered = true" @blur="isSubmittedFirstNameBeingEntered = false" type="text" name="submittedFirstName" class="form-control" maxlength="30" required>
                                            </div>
                                        </div>
                                        <div v-if="isSubmittedPhoneNumberValid" class="form-row">
                                            <div class="form-group col-12" v-bind:class="{ 'valid-group': isSubmittedLastNameValid }">
                                                <label v-bind:class="{ pushed: showPushedSubmittedLastNameLabel }" @click="isSubmittedLastNameBeingEntered = true; this.$refs.refSubmittedLastName.focus();">Last Name</label>
                                                <input v-model="submittedLastName" ref="refSubmittedLastName" @focus="isSubmittedLastNameBeingEntered = true" @blur="blurSubmittedLastName" type="text" name="submittedLastName" class="form-control" maxlength="40" required>
                                            </div>
                                        </div>
                                        <div class="form-row">
                                            <div class="form-group col-12">
                                                <button :disabled="!validateSubmitPhoneAndName" type="button" ref="refSubmitPhoneNumberAndName" v-on:click="submitPhoneAndName" class="btn btn-pink">Continue</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="form-disclaimer">
                                    <h5>Won't hurt your score</h5>
                                    <p>By clicking Continue, you authorize your wireless carrier to disclose your mobile number to our third party service providers to verify your identity and prevent fraud.</p>
                                    <p>Additionally, you authorize {{dealershipName}} and its service providers to obtain your name, address, email and Social Security Number from Equifax in order to validate your identity and/or populate this form.  See our <a target="_blank" href="https://creditdriver.com/terms.html">Privacy Policy</a> for how we handle your data.</p>
                                    <p>You agree that {{dealershipName}} may communicate purchase and/or lease options via email, text, or phone calls.  Moreover, you agree to the <a target="_blank" href="https://creditdriver.com/terms.html">Terms and Conditions</a>.</p>
                                </div>

                            </div>

                            <div v-show="visibleRightTab == 'showSubmitLast4SSN'">

                                <div class="form-top">
                                    <div class="form-lang">
                                    </div>
                                    <div class="form-close">
                                        <p>Get pre-qualified <strong>in seconds</strong></p>
                                    </div>
                                    <div class="form-logo">
                                        <img :src="urlToLogo" alt="img" class="img-fluid" style="max-height: 90px;">
                                    </div>
                                </div>


                                <div class="video-area">
                                    <div class="video-block">
                                        <div class="video-img">
                                            <img src="../assets/video-thumbnail2@2x.png" alt="img" class="img-fluid">
                                        </div>
                                        <div class="video-play">
                                            <a @click.prevent="playModalHelpVideo" href="#" data-toggle="modal" data-target="#videoModal"><img src="../assets/video-play-button.svg" alt="img" class="img-fluid"></a>
                                        </div>
                                    </div>
                                </div>


                                <div class="main-form">
                                    <div class="form-head">
                                        <h1><strong>You're on the way</strong> to pre-qualification.</h1>
                                        <p>Unlock your buying power and see your free credit score.</p>
                                    </div>

                                    <div class="form-block">
                                        <div class="form-row">
                                            <div class="form-group col-12" v-bind:class="{ 'valid-group': isSubmittedZipCodeValid }">
                                                <label v-bind:class="{ pushed: showPushedSubmittedZipCodeLabel }" @click="isSubmittedZipCodeBeingEntered = true; this.$refs.refSubmittedZipCode.focus();">Zip Code</label>
                                                <input v-model="submittedZipCode" v-mask="'#####'" ref="refSubmittedZipCode" @focus="isSubmittedZipCodeBeingEntered = true" @blur="isSubmittedZipCodeBeingEntered = false" type="text" name="zipcode" class="form-control" maxlength="5" required>
                                            </div>
                                        </div>
                                        <div class="form-row">
                                            <div class="form-group col-12" v-bind:class="{ 'valid-group': isLast4SSNValid }">
                                                <label v-bind:class="{ pushed: showPushedLast4SSNLabel }" @click="isLast4SSNBeingEntered = true; this.$refs.refLast4ssn.focus();">Last 4 of Social (SSN)</label>
                                                <input v-model="last4ssn" v-mask="'!X!X!X-!X!X-####'" ref="refLast4ssn" @focus="isLast4SSNBeingEntered = true" @blur="isLast4SSNBeingEntered = false" type="text" name="ssnumber" id="ssNumber" class="form-control" required>
                                            </div>
                                        </div>
                                        <div class="form-row">
                                            <div class="form-group col-12">
                                                <button :disabled="!validateSubmitLast4SSN" type="button" v-on:click="submitLast4SSN" class="btn btn-pink">Continue</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                            </div>

                            <div v-show="visibleRightTab == 'showSubmitPhoneNumberForOneTimePassword'">

                                <div class="form-top">
                                    <div class="form-lang">
                                    </div>
                                    <div class="form-close">
                                        <p>Get pre-qualified <strong>in seconds</strong></p>
                                    </div>
                                    <div class="form-logo">
                                        <img :src="urlToLogo" alt="img" class="img-fluid" style="max-height: 90px;">
                                    </div>
                                </div>


                                <div class="video-area">
                                    <div class="video-block">
                                        <div class="video-img">
                                            <img src="../assets/video-thumbnail2@2x.png" alt="img" class="img-fluid">
                                        </div>
                                        <div class="video-play">
                                            <a @click.prevent="playModalHelpVideo" href="#" data-toggle="modal" data-target="#videoModal"><img src="../assets/video-play-button.svg" alt="img" class="img-fluid"></a>
                                        </div>
                                    </div>
                                </div>


                                <div class="main-form">
                                    <div class="form-head">
                                        <h1><strong>Almost there</strong>, we just need to verify your identity.</h1>
                                    </div>

                                    <div class="form-block">
                                        <div class="form-row custom-row">
                                            <div class="form-group editable-link col-12" data-target="edit-phone">
                                                <label class="pushed">Phone number</label>
                                                <input v-model="submittedPhoneNumber" v-mask="'###-###-####'" ref="refSubmittedPhoneNumber2" type="text" name="phone" id="phoneField" class="form-control" :disabled="!enableEditSubmittedPhoneNumber" maxlength="12" required>
                                                <a href="#" class="edit-link" @click.stop="enableEditSubmittedPhoneNumber = !enableEditSubmittedPhoneNumber">{{editSubmittedPhoneNumberLabelText}}</a>
                                            </div>
                                        </div>
                                        <br v-if="showEnterTheCode" />
                                        <div v-if="showEnterTheCode" class="form-row custom-row" id="errorField">
                                            <div class="form-group col-12">
                                                <label v-bind:class="{ pushed: showPushedOneTimePasswordLabel }" @click.stop="isOneTimePasswordBeingEntered = true; this.$refs.refOneTimePassword.focus();">Enter the code</label>
                                                <input v-model="oneTimePassword" v-mask="'######'" ref="refOneTimePassword" @focus="isOneTimePasswordBeingEntered = true" @blur="isOneTimePasswordBeingEntered = false" type="text" name="code" class="form-control" maxlength="6" required>
                                            </div>
                                        </div>
                                        <div class="form-row">
                                            <div class="form-group col-12">
                                                <button type="button" class="btn btn-pink" v-on:click="submitPhoneNumberForOneTimePassword">{{oneTimePasswordSubmitButtonText}}</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="form-method" style="display:none;">
                                    <p>
                                        Don't have access to this cell phone?<br>
                                        <a href="index-2.4.html">Try another method</a>.
                                    </p>
                                </div>

                            </div>

                            <div v-show="visibleRightTab == 'showEnterInformation'">

                                <div class="form-top">
                                    <div class="form-lang">
                                    </div>
                                    <div class="form-close">
                                        <p>Get pre-qualified <strong>in seconds</strong></p>
                                    </div>
                                    <div class="form-logo">
                                        <img :src="urlToLogo" alt="img" class="img-fluid" style="max-height: 90px;">
                                    </div>
                                </div>


                                <div class="main-form">
                                    <div class="form-head">
                                        <h1><strong>You're one click away</strong> from your pre-qualification!</h1>
                                        <p>Confirm the following information is correct to see your buying power:</p>
                                    </div>

                                    <div class="form-block">
                                        <div class="form-row">
                                            <div class="form-group col-8">
                                                <h4>Personal Information</h4>
                                            </div>
                                            <div class="form-group col-4">
                                                <a href="#" class="edit-link float-right" data-point="personal-info" @click.prevent="editPersonalInfo">{{editPersonalInfoLabelText}}</a>
                                            </div>
                                        </div>
                                        <div class="form-row custom-row" data-target="personal-info">
                                            <div class="form-group col-sm-12 col-md-6" v-bind:class="{ 'valid-group': isFirstNameValid, 'error-group': errorFirstName }">
                                                <label v-bind:class="{ pushed: showPushedFirstNameLabel }" @click="isFirstNameBeingEntered = true; this.$refs.refFirstName.focus();">First name</label>
                                                <input v-model="firstName" ref="refFirstName" @focus="isFirstNameBeingEntered = true" @blur="isFirstNameBeingEntered = false; dirtyFirstName = true;" type="text" name="first_name" class="form-control" :disabled="!enableEditPersonalInfo" maxlength="30" required>
                                            </div>
                                            <div class="form-group col-sm-12 col-md-6" v-bind:class="{ 'valid-group': isLastNameValid, 'error-group': errorLastName }">
                                                <label v-bind:class="{ pushed: showPushedLastNameLabel }" @click="isLastNameBeingEntered = true; this.$refs.refLastName.focus();">Last name</label>
                                                <input v-model="lastName" ref="refLastName" @focus="isLastNameBeingEntered = true" @blur="isLastNameBeingEntered = false; dirtyLastName = true;" type="text" name="last_name" class="form-control" :disabled="!enableEditPersonalInfo" maxlength="40" required>
                                            </div>
                                        </div>
                                        <div class="form-row custom-row" data-target="personal-info">
                                            <div class="form-group col-sm-12 col-md-6" v-bind:class="{ 'valid-group': isPhoneNumberValid, 'error-group': errorPhoneNumber }">
                                                <label v-bind:class="{ pushed: showPushedPhoneNumberLabel }" @click="isPhoneNumberBeingEntered = true; this.$refs.refPhoneNumber.focus();">Phone number</label>
                                                <input v-model="phoneNumber" v-mask="'###-###-####'" ref="refPhoneNumber" @focus="isPhoneNumberBeingEntered = true" @blur="isPhoneNumberBeingEntered = false; dirtyPhoneNumber = true;" type="tel" name="phone_number" class="form-control" :disabled="!enableEditPersonalInfo" maxlength="12" required>
                                            </div>
                                            <div v-if="enableEditPersonalInfo" class="form-group col-sm-12 col-md-6" v-bind:class="{ 'valid-group': isFullSSNValid, 'error-group': errorFullSSN }">
                                                <label v-bind:class="{ pushed: showPushedFullSSNLabel }" @click="isFullSSNBeingEntered = true; this.$refs.refFullSSN.focus();">SSN</label>
                                                <input v-model="fullSSN" v-mask="'###-##-####'" ref="refFullSSN" @focus="isFullSSNBeingEntered = true" @blur="isFullSSNBeingEntered = false; dirtyFullSSN = true;" type="tel" name="fullssn" class="form-control" :disabled="!enableEditPersonalInfo" maxlength="256" required>
                                            </div>
                                            <div v-else class="form-group col-sm-12 col-md-6" v-bind:class="{ 'valid-group': isFullSSNValid, 'error-group': errorFullSSN }">
                                                <label v-bind:class="{ pushed: showPushedFullSSNLabel }" @click="isFullSSNBeingEntered = true; this.$refs.refFullSSNDisplay.focus();">SSN</label>
                                                <input v-model="fullSSNMasked" ref="refFullSSNDisplay" @focus="isFullSSNBeingEntered = true" @blur="isFullSSNBeingEntered = false; dirtyFullSSN = true;" type="tel" name="fullssn" class="form-control" :disabled="!enableEditPersonalInfo" maxlength="256" required>
                                            </div>
                                        </div>
                                        <div class="form-row custom-row" data-target="personal-info">
                                            <div class="form-group col-sm-12 col-md-6" v-bind:class="{ 'valid-group': isEmailValid, 'error-group': errorEmail }">
                                                <label v-bind:class="{ pushed: showPushedEmailLabel }" @click="isEmailBeingEntered = true; this.$refs.refEmail.focus();">Email address</label>
                                                <input v-model="email" ref="refEmail" @focus="isEmailBeingEntered = true" @blur="isEmailBeingEntered = false; dirtyEmail = true;" type="email" name="email" class="form-control" :disabled="!enableEditPersonalInfo" maxlength="256" required>
                                            </div>
                                            <div class="form-group col-sm-12 col-md-6" v-bind:class="{ 'valid-group': isDateOfBirthValid, 'error-group': errorDateOfBirth }">
                                                <label v-bind:class="{ pushed: showPushedDateOfBirthLabel }" @click="isDateOfBirthBeingEntered = true; this.$refs.refDateOfBirth.focus();">Date of birth</label>
                                                <input v-model="dateOfBirth" v-mask="'##/##/####'" ref="refDateOfBirth" @focus="isDateOfBirthBeingEntered = true" @blur="isDateOfBirthBeingEntered = false; dirtyDateOfBirth = true;" type="tel" name="date_of_birth" placeholder="MM/DD/YYYY" class="form-control" :disabled="!enableEditPersonalInfo" maxlength="10" required>
                                            </div>
                                        </div>

                                        <div class="form-row pt-4">
                                            <div class="form-group col-8">
                                                <h4>Address</h4>
                                            </div>
                                            <div class="form-group col-4">
                                                <a href="#" class="edit-link float-right" data-point="address" @click.prevent="editAddressInfo">{{editAddressInfoLabelText}}</a>
                                            </div>
                                        </div>
                                        <div class="form-row custom-row" data-target="address">
                                            <div v-if="enableEditAddressInfo" class="form-group col-sm-12 col-md-6" v-bind:class="{ 'valid-group': isStreetAddressValid, 'error-group': errorStreetAddress }">
                                                <label v-bind:class="{ pushed: showPushedStreetAddressLabel }" @click="isStreetAddressBeingEntered = true; this.$refs.refStreetAddress.focus();">Street address</label>
                                                <input v-model="streetAddress" ref="refStreetAddress" @focus="isStreetAddressBeingEntered = true" @blur="isStreetAddressBeingEntered = false" type="text" name="street_address" class="form-control" :disabled="!enableEditAddressInfo" maxlength="100" required>
                                            </div>
                                            <div v-else class="form-group col-sm-12 col-md-6" v-bind:class="{ 'valid-group': isStreetAddressValid, 'error-group': errorStreetAddress }">
                                                <label v-bind:class="{ pushed: showPushedStreetAddressLabel }" @click="isStreetAddressBeingEntered = true; this.$refs.refStreetAddressShort.focus();">Street address</label>
                                                <input v-model="shortStreetAddress" ref="refStreetAddressShort" @focus="isStreetAddressBeingEntered = true" @blur="isStreetAddressBeingEntered = false" type="text" name="street_address" class="form-control" :disabled="!enableEditAddressInfo" maxlength="100" required>
                                            </div>
                                            <div class="form-group col-sm-12 col-md-6" v-bind:class="{ 'valid-group': isZipCodeValid, 'error-group': errorZipCode }">
                                                <label v-bind:class="{ pushed: showPushedZipCodeLabel }" @click="isZipCodeBeingEntered = true; this.$refs.refZipCode.focus();">Zip</label>
                                                <input v-model="zipCode" v-mask="'#####'" ref="refZipCode" @focus="isZipCodeBeingEntered = true" @blur="isZipCodeBeingEntered = false" type="text" name="zip" class="form-control" :disabled="!enableEditAddressInfo" maxlength="5" required>
                                            </div>
                                        </div>
                                        <div class="form-row custom-row" data-target="address">
                                            <div class="form-group col-sm-12 col-md-6" v-bind:class="{ 'valid-group': isCityValid, 'error-group': errorCity }">
                                                <label v-bind:class="{ pushed: showPushedCityLabel }" @click="isCityBeingEntered = true; this.$refs.refCity.focus();">City</label>
                                                <input v-model="city" ref="refCity" @focus="isCityBeingEntered = true" @blur="isCityBeingEntered = false" type="text" name="city" class="form-control" :disabled="!enableEditAddressInfo" maxlength="50" required>
                                            </div>
                                            <div class="form-group col-sm-12 col-md-6" v-bind:class="{ 'valid-group': isStateValid, 'error-group': errorState }">
                                                <label v-bind:class="{ pushed: showPushedStateLabel }" @click="isStateBeingEntered = true; this.$refs.refState.focus();">State</label>
                                                <input v-model="state" v-mask="'AA'" ref="refState" @focus="isStateBeingEntered = true" @blur="isStateBeingEntered = false" type="text" name="state" class="form-control" :disabled="!enableEditAddressInfo" maxlength="2" required>
                                            </div>
                                        </div>

                                        <div class="form-row hide-small">
                                            <div class="form-group col-12">
                                                <button v-on:click="submitCandidateInformation" type="button" :disabled="!validateEnterInformation" class="btn btn-pink">Confirm</button>
                                            </div>
                                        </div>

                                        <div class="form-row fixed-submit hide-large">
                                            <div class="form-group col-12">
                                                <button v-on:click="submitCandidateInformation" type="button" :disabled="!validateEnterInformation" class="btn btn-pink">Confirm</button>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="form-disclaimer">
                                        <p>1.	You are providing express written consent under the <a target="_blank" href="https://www.consumer.ftc.gov/articles/pdf-0096-fair-credit-reporting-act.pdf">Fair Credit Reporting Act</a>, for <strong>{{dealershipName}}</strong> to obtain a copy of your credit report for the purpose of determining if you pre-qualify for installment credit financing if you purchase a vehicle from <strong>{{dealershipName}}</strong>, this is not a firm offer of credit, nor is this a full application for credit financing. Your final approval will be subject to a full credit application where a separate hard inquiry credit report may be obtained. For this pre-qualification transaction, your Social Security Number is not required and there will be no effect upon your credit report or credit score.</p>
                                        <p>2.	Consent for contact and digital communication: By providing my contact information and clicking "Confirm", I confirm I have read and agree to the <a target="_blank" href="https://creditdriver.com/terms.html">Terms</a> and Conditions and agree <strong>{{dealershipName}}</strong> can contact me about my purchase and financing of vehicles at the number I provide via call, text, email, prerecorded message and automatic dialer.</p>
                                    </div>

                                </div>

                            </div>

                            <div v-show="visibleRightTab == 'showCheckSecureMFA'">
                                <p class="lead">A text message has been sent to your mobile phone.  Please click on the link within the next 4 minutes to continue.</p>
                            </div>

                            <div v-show="visibleRightTab == 'showCheckSecureMFAForLogin'">
                                <h3>We found a profile for the phone number you entered</h3>
                                <p class="lead" style="margin-top:20px;">A text message has been sent to your mobile phone.  Please click on the link within the next 4 minutes to login to your profile.</p>
                            </div>

                            <div v-show="visibleRightTab == 'showLoginWithSecureMFAFailed'">
                                <p class="lead">The link in the text message sent to your mobile phone expired before it was used.  <a @click.prevent="loginWithSecureMFA" href="#">Click here</a> to try again.</p>
                            </div>

                        </div>

                    </div>

                </div>

            </form>

            <div v-else-if="showDashboard">
                <CandidateDashboard v-bind:candidateId="candidateId"
                                    v-bind:candidateGuid="candidateGuid"
                                    v-bind:firstName="firstName"
                                    v-bind:lastName="lastName"
                                    v-bind:dealershipName="dealershipName"
                                    v-bind:dealershipStreetAddress="dealershipStreetAddress"
                                    v-bind:dealershipCity="dealershipCity"
                                    v-bind:dealershipStateCode="dealershipStateCode"
                                    v-bind:dealershipZipCode="dealershipZipCode"
                                    v-bind:dealershipPhoneNumber="dealershipPhoneNumber"
                                    v-bind:dealershipEmail="dealershipEmail"
                                    v-bind:hideAverageAPROnConsumerDashboard="hideAverageAPROnConsumerDashboard"
                                    v-bind:hideAverageLoanAmountOnConsumerDashboard="hideAverageLoanAmountOnConsumerDashboard"
                                    v-bind:hideCreditScoreOnConsumerDashboard="hideCreditScoreOnConsumerDashboard"
                                    v-bind:salesRepEmail="salesRepEmail"
                                    v-bind:salesRepPhoneNumber="salesRepPhoneNumber"
                                    v-bind:salesRepFirstName="salesRepFirstName"
                                    v-bind:salesRepLastName="salesRepLastName"
                                    v-bind:sessionId="sessionId"
                                    v-bind:creditScore="creditScore"
                                    v-bind:autoLines="autoLines"
                                    v-bind:urlToLogo="normalizedLogoUrl"/>
            </div>

        </div>

        <div id="myModal" class="modal">
            <div class="modal-content">
                <video id="helpVideoPlayer" class="video" style="width:100%; height:100%;" controls>
                    <source src="../assets/cd-helper.mp4" type="video/mp4">
                </video>
            </div>
        </div>

        <div class="modal fade" id="videoModal" tabindex="-1" aria-labelledby="videoModalLabel" aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">

                    </div>
                </div>
            </div>
        </div>
    </div>

    <!--
    <div class="form-group">
        <label for="txtfirstName">First Name</label>
        <input v-model="firstName" type="text" class="form-control" id="txtfirstName" placeholder="First Name">
    </div>
    <div class="form-group">
        <label for="txtMiddleName">Middle Name</label>
        <input v-model="middleName" type="text" class="form-control" id="txtMiddleName" placeholder="Middle Name">
    </div>
    <div class="form-group">
        <label for="txtLastName">Last Name</label>
        <input v-model="lastName" type="text" class="form-control" id="txtLastName" placeholder="Last Name">
    </div>
    <div class="form-group">
        <label for="txtNameSuffix">Last Name</label>
        <input v-model="nameSuffix" type="text" class="form-control" id="txtNameSuffix" placeholder="Suffix">
    </div>
    <div class="form-group">
        <div class="col-sm-3">
            <label for="txtHouseNumber">House Number</label>
            <input v-model="houseNumber" type="text" class="form-control" id="txtHouseNumber" placeholder="House Number">
        </div>
        <div class="col-sm-6">
            <label for="txtStreetAddress">Street Address</label>
            <input v-model="streetAddress" type="text" class="form-control" id="txtStreetAddress" placeholder="Street Address">
        </div>
        <div class="col-sm-3">
            <label for="txtStreetType">Street Type</label>
            <input v-model="streetType" type="text" class="form-control" id="txtStreetType" placeholder="Street Type">
        </div>
    </div>
    <div class="form-group">
        <label for="txtApartmentNumber">City</label>
        <input v-model="apartmentNumber" type="text" class="form-control" id="txtApartmentNumber" placeholder="Apartment Number">
    </div>
    <div class="form-group">
        <label for="txtCity">City</label>
        <input v-model="city" type="text" class="form-control" id="txtCity" placeholder="City">
    </div>
    <div class="form-group">
        <label for="txtState">State</label>
        <input v-model="state" type="text" class="form-control" id="txtState" placeholder="State">
    </div>
    <div class="form-group">
        <label for="txtZipCode">State</label>
        <input v-model="zipCode" type="text" class="form-control" id="txtZipCode" placeholder="Zip Code">
    </div>
    <div class="form-group">
        <label for="txtFullSSN">Social Security Number</label>
        <input v-model="fullSSN" type="text" class="form-control" id="txtFullSSN" placeholder="Social Security Number">
    </div>
    <div class="form-group">
        <label for="txtDateOfBirth">Date of Birth</label>
        <input v-model="dateOfBirth" type="text" class="form-control" id="txtDateOfBirth" placeholder="Date of Birth">
    </div>
    <button class="btn btn-submit" type="button" v-on:click="submitCandidateInformation">Continue</button>
        -->
    <!-- Modal -->


</template>

<script>
    //import axios from 'axios';
    import CandidateDashboard from './CandidateDashboard.vue';
    import creditDriverApi from '../creditDriverApi';
    import { mask } from 'vue-the-mask'
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/vue-loading.css';

    export default {
        name: 'CandidateApply',
        props: {

        },
        data: function () {
            return {
                candidateId: 0,
                candidateGuid: "",
                carrierUrl: "",
                city: "",
                creditReportPDFhref: "",
                creditReportJSON: "",
                creditScore: 580,
                dateOfBirth: "",
                //dealershipGuid: "b9022728-3124-4a74-b3a9-5422eaf2ae7e",
                dealershipId: 0,
                leadGroupId: 0,
                dealershipName: "",
                dealershipStreetAddress: "",
                dealershipCity: "",
                dealershipStateCode: "",
                dealershipZipCode: "",
                dealershipPhoneNumber: "",
                dealershipEmail: "",
                hideAverageAPROnConsumerDashboard: false,
                hideAverageLoanAmountOnConsumerDashboard: false,
                hideCreditScoreOnConsumerDashboard: false,
                dirtyFirstName: false,
                dirtyLastName: false,
                dirtyPhoneNumber: false,
                dirtyEmail: false,
                dirtyDateOfBirth: false,
                dirtyFullSSN: false,
                dirtyStreetAddress: false,
                dirtyZipCode: false,
                dirtyCity: false,
                dirtyState: false,
                email: "",
                enableEditSubmittedPhoneNumber: false,
                enableEditPersonalInfo: false,
                enableEditAddressInfo: false,
                firstName: "",
                fullSSN: "",
                last4ssn: "",
                lastName: "",
                instaTouchIDPrefilled: false,
                ioBB: "",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;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",
                isSubmittedZipCodeBeingEntered: false,
                isLast4SSNBeingEntered: false,
                isLoading: false,
                isPlayingMainVideo: false,
                isSubmittedPhoneNumberBeingEntered: false,
                isSubmittedFirstNameBeingEntered: false,
                isSubmittedLastNameBeingEntered: false,
                isFirstNameBeingEntered: false,
                isLastNameBeingEntered: false,
                isPhoneNumberBeingEntered: false,
                isEmailBeingEntered: false,
                isDateOfBirthBeingEntered: false,
                isFullSSNBeingEntered: false,
                isStreetAddressBeingEntered: false,
                isCityBeingEntered: false,
                isStateBeingEntered: false,
                isZipCodeBeingEntered: false,
                isOneTimePasswordBeingEntered: false,
                mfaSessionId: "",
                mobileWorkFlow: false,
                oneTimePassword: "",
                otpTransactionId: "",
                phoneNumber: "",
                secureMFAStatus: "",
                secureMFATimerID: 0,
                secureMFAValidateAttemptCount: 0,
                secureMFALoginAlreadySent: false,
                sessionId: "",
                showDashboard: false,
                showEnterTheCode: false,
                streetAddress: "",
                state: "",
                submittedFirstName: "",
                submittedLastName: "",
                submittedPhoneNumber: "",
                submittedZipCode: "",
                visibleRightTab: "",
                zipCode: "",
                urlToLogo: "",
                autoLines: [],
                dsgssCustomerId: "",
                clientSource: "",
                prefillPhoneNumber: ""
            }
        },
        watch: {
            submittedPhoneNumber() { //newSubmittedPhoneNumber, oldSubmittedPhoneNumber
                this.watchSubmittedPhoneNumber();
            }
        },
        computed: {
            fullSSNMasked() {
                return "XXX-XX-" + this.fullSSN.slice(this.fullSSN.length - 4);
            },
            last4ssnWithoutMask() {
                if (this.isLast4SSNValid) {
                    return this.last4ssn.slice(this.last4ssn.length - 4);
                }
                else {
                    return "";
                }
            },
            shortStreetAddress() {
                return this.streetAddress.slice(0, 16) + "...";
            },
            isSubmittedZipCodeValid() {
                return this.submittedZipCode != "" && this.submittedZipCode.length == 5;
            },
            isLast4SSNValid() {
                return this.last4ssn != "" && this.last4ssn.length == 11;
            },
            isSubmittedPhoneNumberValid() {
                return this.submittedPhoneNumber != "" && this.submittedPhoneNumber.length == 12;
            },
            isSubmittedFirstNameValid() {
                return this.submittedFirstName != "";
            },
            isSubmittedLastNameValid() {
                return this.submittedLastName != "";
            },
            isFirstNameValid() {
                return this.firstName != "";
            },
            isLastNameValid() {
                return this.lastName != "";
            },
            isPhoneNumberValid() {
                return this.phoneNumber != "" && this.phoneNumber.length == 12;
            },
            isEmailValid() {
                return this.email != "" && this.email.includes("@") && this.email.includes(".");
            },
            isDateOfBirthValid() {
                if (this.dateOfBirth.length !== 10) {
                    return false;
                }

                const [month, day, year] = this.dateOfBirth.split("/").map(Number);
                const parsed = new Date(year, month - 1, day);

                return parsed.getFullYear() === year && parsed.getMonth() === month - 1 && parsed.getDate() === day && parsed <= new Date();
            },
            dateOfBirthIso() {
                // The confirm screen requires a full MM/DD/YYYY (see isDateOfBirthValid), but this.dateOfBirth can
                // still be a year-less "MM/DD" here if InstaTouch prefill ran and the candidate hasn't reached
                // (or passed) that screen yet. DateTimeOffset? on the backend requires a full ISO date either way.
                const parts = this.dateOfBirth.split("/");
                if (parts.length !== 3) {
                    return null;
                }

                const [month, day, year] = parts;
                return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
            },
            isFullSSNValid() {
                return this.fullSSN != "" && (this.fullSSN.length == 11 || this.fullSSN.length == 9);
            },
            isStreetAddressValid() {
                return this.streetAddress != "";
            },
            isZipCodeValid() {
                return this.zipCode != "" && this.zipCode.length == 5;
            },
            isCityValid() {
                return this.city != "";
            },
            isStateValid() {
                return this.state != "" && this.state.length == 2;
            },
            errorFirstName() {
                return this.dirtyFirstName && !this.isFirstNameValid;
            },
            errorLastName() {
                return this.dirtyLastName && !this.isLastNameValid;
            },
            errorPhoneNumber() {
                return this.dirtyPhoneNumber && !this.isPhoneNumberValid;
            },
            errorEmail() {
                return this.dirtyEmail && !this.isEmailValid;
            },
            errorDateOfBirth() {
                return this.dirtyDateOfBirth && !this.isDateOfBirthValid;
            },
            errorFullSSN() {
                return this.dirtyFullSSN && !this.isFullSSNValid;
            },
            errorStreetAddress() {
                return this.dirtyStreetAddress && !this.isStreetAddressValid;
            },
            errorZipCode() {
                return this.dirtyZipCode && !this.isZipCodeValid;
            },
            errorCity() {
                return this.dirtyCity && !this.isCityValid;
            },
            errorState() {
                return this.dirtyState && !this.isStateValid;
            },
            validateSubmitPhoneAndName() {
                return this.isSubmittedPhoneNumberValid && this.isSubmittedFirstNameValid && this.isSubmittedLastNameValid;
            },
            validateSubmitLast4SSN() {
                return this.isSubmittedZipCodeValid && this.isLast4SSNValid;
            },
            validatePersonalInfo() {
                return this.isFirstNameValid && this.isLastNameValid && this.isPhoneNumberValid && this.isEmailValid && this.isDateOfBirthValid && this.isFullSSNValid
            },
            validateAddressInfo() {
                return this.isStreetAddressValid && this.isZipCodeValid && this.isCityValid && this.isStateValid;
            },
            validateEnterInformation() {
                return this.validatePersonalInfo && this.validateAddressInfo;
            },
            showPushedSubmittedZipCodeLabel() {
                return this.isSubmittedZipCodeBeingEntered || this.submittedZipCode != "";
            },
            showPushedLast4SSNLabel() {
                return this.isLast4SSNBeingEntered || this.last4ssn != "";
            },
            showPushedSubmittedPhoneNumberLabel() {
                return this.isSubmittedPhoneNumberBeingEntered || this.submittedPhoneNumber != "";
            },
            showPushedSubmittedFirstNameLabel() {
                return this.isSubmittedFirstNameBeingEntered || this.submittedFirstName != "";
            },
            showPushedSubmittedLastNameLabel() {
                return this.isSubmittedLastNameBeingEntered || this.submittedLastName != "";
            },
            showPushedFirstNameLabel() {
                return this.isFirstNameBeingEntered || this.firstName != "";
            },
            showPushedLastNameLabel() {
                return this.isLastNameBeingEntered || this.lastName != "";
            },
            showPushedPhoneNumberLabel() {
                return this.isPhoneNumberBeingEntered || this.phoneNumber != "";
            },
            showPushedEmailLabel() {
                return this.isEmailBeingEntered || this.email != "";
            },
            showPushedDateOfBirthLabel() {
                return this.isDateOfBirthBeingEntered || this.dateOfBirth != "";
            },
            showPushedFullSSNLabel() {
                return this.isFullSSNBeingEntered || this.fullSSN != "";
            },
            showPushedStreetAddressLabel() {
                return this.isStreetAddressBeingEntered || this.streetAddress != "";
            },
            showPushedCityLabel() {
                return this.isCityBeingEntered || this.city != "";
            },
            showPushedStateLabel() {
                return this.isStateBeingEntered || this.state != "";
            },
            showPushedZipCodeLabel() {
                return this.isZipCodeBeingEntered || this.zipCode != "";
            },
            showPushedOneTimePasswordLabel() {
                return this.isOneTimePasswordBeingEntered || this.oneTimePassword != "";
            },
            editAddressInfoLabelText() {
                return this.enableEditAddressInfo ? "Save" : "Edit";
            },
            editPersonalInfoLabelText() {
                return this.enableEditPersonalInfo ? "Save" : "Edit";
            },
            editSubmittedPhoneNumberLabelText() {
                return this.enableEditSubmittedPhoneNumber ? "Save" : "Edit";
            },
            oneTimePasswordSubmitButtonText() {
                return (this.showEnterTheCode ? "Continue" : "Send code");
            },
            normalizedLogoUrl() {
                return this.normalizeLogoUrl(this.urlToLogo);
            }
        },
        methods: {
            blurSubmittedLastName() {
                this.isSubmittedLastNameBeingEntered = false;
                this.$nextTick(function () {
                    this.$refs.refSubmittedZipCode.focus();
                });
            },
            editPersonalInfo() {
                if (this.enableEditPersonalInfo) {
                    this.dirtyFirstName = true;
                    this.dirtyLastName = true;
                    this.dirtyPhoneNumber = true;
                    this.dirtyEmail = true;
                    this.dirtyDateOfBirth = true;
                    this.dirtyFullSSN = true;
                    if (this.validatePersonalInfo) {
                        this.enableEditPersonalInfo = false;
                    }
                }
                else {
                    this.enableEditPersonalInfo = true;
                }
            },
            editAddressInfo() {
                if (this.enableEditAddressInfo) {
                    this.dirtyStreetAddress = true;
                    this.dirtyZipCode = true;
                    this.dirtyCity = true;
                    this.dirtyState = true;
                    if (this.validateAddressInfo) {
                        this.enableEditAddressInfo = false;
                    }
                }
                else {
                    this.enableEditAddressInfo = true;
                }
            },
            writeSessionToCookie() {
                //Write sessionId to cookie
                var date = new Date();
                var hours = 1;
                date.setTime(date.getTime() + (hours * 60 * 60 * 1000));
                var expires = "; expires=" + date.toUTCString();
                document.cookie = "candidatesessionid=" + this.sessionId + expires + "; path=/";
            },
            deleteSessionCookie() {
                //Delete sessionId to cookie
                var date = new Date();
                var hours = 1;
                date.setTime(date.getTime() - (hours * 60 * 60 * 1000));
                var expires = "; expires=" + date.toUTCString();
                document.cookie = "candidatesessionid=" + expires + "; path=/";
            },
            watchSubmittedPhoneNumber() {
                if (this.isSubmittedPhoneNumberValid) {
                    this.getCandidateFromPhoneNumber();
                }
            },
            hasValidSessionCookie() {
                if (document.cookie != null && document.cookie != "") {
                    if (this.getCook("candidatesessionid") != "") {
                        return true;
                    }
                }

                return false;
            },
            getCandidateFromPhoneNumber() {
                if (this.submittedPhoneNumber == "555-555-5555") {
                    this.deleteSessionCookie();
                    this.skipInstaTouchID();
                }

                if (this.submittedPhoneNumber.length != 12) {
                    return;
                }

                this.isLoading = true;
                creditDriverApi.getCandidateFromPhoneNumber({
                    qrCode: this.$route.params.qrcode,
                    sessionId: this.sessionId,
                    phoneNumber: this.submittedPhoneNumber,
                    dsgssCustomerId: this.dsgssCustomerId
                }).then(response => {
                    if (response.data != null && typeof response.data.firstName !== 'undefined' && response.data.firstName != "") {
                        if (response.data.submitDate != null) {
                            if (this.hasValidSessionCookie()) {
                                this.goToProfileUrl(response.data.candidateGuid);
                            }
                            else {
                                this.candidateGuid = response.data.candidateGuid;
                                this.loginWithSecureMFA();
                            }
                        } else {
                            this.submittedFirstName = response.data.firstName;
                            this.submittedLastName = response.data.lastName;
                            this.$refs.refSubmitPhoneNumberAndName.focus();

                            this.writeSessionToCookie();
                        }
                    }
                    else {
                        this.$refs.refSubmittedFirstName.focus();

                        this.writeSessionToCookie();
                    }

                    this.isLoading = false;
                }).catch(error => {
                    console.log(error);
                }).finally(function () {

                });
            },
            updateCandidatePhoneNumberFirstNameLastName() {
                creditDriverApi.postUpdateCandidate({
                    PhoneNumber: this.submittedPhoneNumber,
                    FirstName: this.submittedFirstName,
                    LastName: this.submittedLastName,
                    EfxSessionId: this.sessionId,
                    DSGSSCustomerId: this.dsgssCustomerId,
                    ClientSource: this.clientSource
                }).then(response => {
                    if (response.data != null) {
                        this.streetAddress = response.data.houseNumber + " " + response.data.streetName + " " + response.data.streetType;
                        this.city = response.data.city;
                        this.state = response.data.stateCode;
                        this.zipCode = response.data.zipCode;
                        this.email = response.data.email;
                    }
                }).catch(error => {
                    console.log(error);
                }).finally(function () {

                });
            },
            updateCandidateZipCodeLast4SSN() {
                creditDriverApi.postUpdateCandidate({
                    ZipCode: this.submittedZipCode,
                    Last4SSN: this.last4ssnWithoutMask,
                    EfxSessionId: this.sessionId
                }).then(response => {
                    if (response.data != null) {
                        console.log('updateCandidateZipCodeLast4SSN');
                    }
                }).catch(error => {
                    console.log(error);
                }).finally(function () {

                });
            },
            goToProfileUrl(candidateGuid) {
                this.isLoading = true;
                window.location = "/candidate/profile/" + candidateGuid;
            },
            goToProfile() {
                if (this.hasValidSessionCookie()) {
                    this.sessionId = this.getCook("candidatesessionid");
                }

                this.isLoading = true;

                creditDriverApi.getSecureCandidateFromCandidateGuid({
                    candidateGuid: this.candidateGuid,
                    efxSessionId: this.sessionId
                }).then(response => {
                    if (response.data != null && response.data.id > 0) {
                        this.candidateId = response.data.id;
                        this.phoneNumber = response.data.phoneNumber;
                        this.firstName = response.data.firstName;
                        this.lastName = response.data.lastName;
                        this.sessionId = response.data.efxSessionId;
                        this.creditScore = response.data.creditScore;
                        this.autoLines = null;
                        this.dealershipId = response.data.dealershipId;
                        this.leadGroupId = response.data.leadGroupId;

                        this.getDealershipAndSalesRepFromDealershipIdAndLeadGroupId();
                    } else {
                        if (this.secureMFALoginAlreadySent) {
                            this.secureMFALoginAlreadySent = false;
                            alert("Error accessing profile!");
                        } else {
                            this.loginWithSecureMFA();
                        }
                    }

                    this.isLoading = false;
                }).catch(error => {
                    console.log(error);
                }).finally(function () {

                });
            },
            getDealershipAndSalesRepFromDealershipIdAndLeadGroupId() {
                this.isLoading = true;

                creditDriverApi.getDealershipAndSalesPersonFromDealershipIdAndLeadGroupId(this.dealershipId, this.leadGroupId).then(response => {
                    if (response.data != null) {
                        this.isLoading = false;

                        this.dealershipName = response.data.dealershipName;
                        this.dealershipStreetAddress = response.data.dealershipStreetAddress;
                        this.dealershipCity = response.data.dealershipCity;
                        this.dealershipStateCode = response.data.dealershipStateCode;
                        this.dealershipZipCode = response.data.dealershipZipCode;
                        this.dealershipPhoneNumber = response.data.dealershipPhoneNumber;
                        this.hideAverageAPROnConsumerDashboard = response.data.hideAverageAPROnConsumerDashboard;
                        this.hideAverageLoanAmountOnConsumerDashboard = response.data.hideAverageLoanAmountOnConsumerDashboard;
                        this.hideCreditScoreOnConsumerDashboard = response.data.hideCreditScoreOnConsumerDashboard;
                        this.urlToLogo = this.normalizeLogoUrl(response.data.urlToDealershipLogo);
                        this.salesRepEmail = response.data.salesRepEmail;
                        this.salesRepPhoneNumber = response.data.salesRepPhoneNumber;
                        this.salesRepFirstName = response.data.salesRepFirstName;
                        this.salesRepLastName = response.data.salesRepLastName;

                        this.showDashboard = true;
                    }

                }).catch(error => {
                    console.log(error);
                }).finally(function () {

                });
            },
            normalizeLogoUrl(url) {
                try {
                    if (!url) return '';
                    // already absolute
                    if (url.startsWith('http://') || url.startsWith('https://')) return url;
                    // protocol-relative
                    if (url.startsWith('//')) return window.location.protocol + url;
                    // site-relative
                    if (url.startsWith('/')) return window.location.origin + url;
                    // relative path without leading slash
                    return window.location.origin + '/' + url.replace(/^\/+/, '');
                } catch (e) {
                    return '';
                }
            },
            loginWithSecureMFA() {
                this.visibleRightTab = "showCheckSecureMFAForLogin";
                this.scrollToTopOfPage();

                this.isLoading = true;
                creditDriverApi.postLoginWithSecureMFA({
                    CandidateGuid: this.candidateGuid
                }).then(response => {
                    if (response.data != null) {
                        this.mfaSessionId = response.data.sessionId;

                        this.secureMFAValidateAttemptCount = 0;
                        this.secureMFALoginAlreadySent = true;
                        this.pollForLoginSecureMFAStatus();

                        this.isLoading = false;
                    }
                    this.isLoading = false;
                }).catch(error => {
                    console.log(error);
                }).finally(function () {

                });
            },
            pollForLoginSecureMFAStatus() {
                var localMFASessionId = this.mfaSessionId;
                var localCandidateGuid = this.candidateGuid;
                this.secureMFAValidateAttemptCount = 0;
                var that = this;

                this.secureMFATimerID = setTimeout(function () {
                    const mfaValidatePostData = {
                        MfaSessionId: localMFASessionId,
                        CandidateGuid: localCandidateGuid
                    };

                    creditDriverApi.postGetSecureMFAStatusForLogin(mfaValidatePostData).then(response => {

                        that.secureMFAValidateAttemptCount++;

                        //alert(response.data.secureMFAStatus);

                        if (response.data.secureMFAStatus == "Green" || response.data.secureMFAStatus == "Yellow") {
                            that.sessionId = response.data.efxSessionId;
                            that.writeSessionToCookie();
                            clearTimeout(that.secureMFATimerID);
                            that.goToProfileUrl(localCandidateGuid);
                        }
                        else if (response.data.secureMFAStatus == "Orange" || response.data.secureMFAStatus == "Red" || response.data.secureMFAStatus == "") {
                            clearTimeout(that.secureMFATimerID);
                            that.visibleRightTab = "showLoginWithSecureMFAFailed";
                            that.scrollToTopOfPage();
                        }
                        else if (response.data.secureMFAStatus == "OP.B1011") {
                            if (that.secureMFAValidateAttemptCount < 12) {
                                that.pollForLoginSecureMFAStatus();
                            }
                            else {
                                clearTimeout(that.secureMFATimerID);
                                that.visibleRightTab = "showLoginWithSecureMFAFailed";
                                that.scrollToTopOfPage();
                            }
                        }

                    }).catch(error => {
                        alert(error);
                        console.log(error);
                    }).finally(function () {

                    });
                },
                    15000
                );
            },
            getCarrierUrl() {
                /*if (this.hasValidSessionCookie()) {
                    this.sessionId = document.cookie.replace("sessionid=", "");

                    this.isLoading = true;

                    creditDriverApi.getCandidateFromSessionId({
                        sessionId: this.sessionId
                    }).then(response => {
                        if (response.data != null && response.data.submitDate != null) {
                            this.isLoading = false;

                            this.candidateGuid = response.data.candidateGuid;
                            this.goToProfile();
                        }
                        else {
                            this.isLoading = false;
                            this.continueGetCarrierUrl();
                        }
                    }).catch(error => {
                        console.log(error);
                    }).finally(function () {

                    });
                } else {*/
                    this.continueGetCarrierUrl();
                //}
            },
            continueGetCarrierUrl() {

                var thisCached = this;

                this.isLoading = true;

                creditDriverApi.getInstaTouchIDGetCarrierUrl(this.$route.params.dealership, this.$route.params.qrcode).then(response => {
                    console.log('API Response:', response.data);
                    console.log('urlToDealershipLogo from API:', response.data.urlToDealershipLogo);

                    // Always set dealership info (logo, name, etc.) even if there's an error message
                    // Only skip the entire block if response.data itself is null/undefined
                    if (response.data != null) {
                        this.carrierUrl = response.data.carrierUrl;
                        this.sessionId = response.data.sessionId;
                        this.dealershipName = response.data.dealershipName;
                        this.dealershipStreetAddress = response.data.dealershipStreetAddress;
                        this.dealershipCity = response.data.dealershipCity;
                        this.dealershipStateCode = response.data.dealershipStateCode;
                        this.dealershipZipCode = response.data.dealershipZipCode;
                        this.dealershipPhoneNumber = response.data.dealershipPhoneNumber;
                        this.hideAverageAPROnConsumerDashboard = response.data.hideAverageAPROnConsumerDashboard;
                        this.hideAverageLoanAmountOnConsumerDashboard = response.data.hideAverageLoanAmountOnConsumerDashboard;
                        this.hideCreditScoreOnConsumerDashboard = response.data.hideCreditScoreOnConsumerDashboard;
                        this.urlToLogo = this.normalizeLogoUrl(response.data.urlToDealershipLogo);
                        this.salesRepEmail = response.data.salesRepEmail;
                        this.salesRepPhoneNumber = response.data.salesRepPhoneNumber;
                        this.salesRepFirstName = response.data.salesRepFirstName;
                        this.salesRepLastName = response.data.salesRepLastName;

                        if (this.carrierUrl === null || this.carrierUrl === "") {
                            this.mobileWorkFlow = false;
                        }

                        if (this.mobileWorkFlow) {

                            var img = document.getElementById("hiddenImage");
                            img.addEventListener('load', function () {
                                // Header enrichment / MDN identification is complete
                                //thisCached.showSubmitPhoneNumber = true;
                                thisCached.visibleRightTab = "showSubmitPhoneAndName";
                            });
                            img.addEventListener('error', function () {
                                // Header enrichment / MDN identification is complete
                                //thisCached.showSubmitPhoneNumber = true;
                                thisCached.visibleRightTab = "showSubmitPhoneAndName";
                            });
                        }
                        else {
                            thisCached.visibleRightTab = "showSubmitPhoneAndName";
                        }

                        thisCached.scrollToTopOfPage();
                        thisCached.isLoading = false;

                        //If we have a phone number to prefill from the QR code, then set submittedPhoneNumber now
                        if (thisCached.prefillPhoneNumber) {
                            thisCached.submittedPhoneNumber = thisCached.prefillPhoneNumber;
                        }
                    } else {
                        thisCached.skipInstaTouchID();
                        return;
                    }
                }).catch(error => {
                    console.log(error);
                }).finally(function () {

                });
            },
            submitConsentAndGetConsumerIdentity() {

                this.isLoading = true;

                creditDriverApi.postInstaTouchIDSubmitConsentAndGetConsumerIdentity({
                    sessionId: this.sessionId,
                    zipCode: this.submittedZipCode,
                    ssn: this.last4ssnWithoutMask
                }).then(response => {
                    //if otpTransactionId is empty, then this is the mobile workflow, otherwise an OTP was sent to the candidate
                    if (response.data === null) {
                        this.skipInstaTouchID();
                        return;
                    }

                    this.firstName = this.isNull(response.data.identity.name.firstName);
                    this.lastName = this.isNull(response.data.identity.name.lastName);

                    this.phoneNumber = (response.data.identity.contact.mobile != null
                        && response.data.identity.contact.mobile != "" ? response.data.identity.contact.mobile :
                        this.isNull(response.data.identity.contact.homePhone));
                    this.email = this.isNull(response.data.identity.contact.email);
                    if (this.email == "") {
                        this.dirtyEmail = true;
                    }

                    if (response.data.identity.addresses[0] !== null) {
                        this.streetAddress = this.isNull(response.data.identity.addresses[0].streetAddress);
                        this.city = this.isNull(response.data.identity.addresses[0].city);
                        this.state = this.isNull(response.data.identity.addresses[0].state);
                        this.zipCode = this.isNull(response.data.identity.addresses[0].zipCode);
                    }

                    this.fullSSN = this.isNull(response.data.identification.ssn);
                    this.dateOfBirth = this.isNull(response.data.identification.dob);

                    //If the phone number is longer than 10 digits and starts with 1, remove the leading 1
                    if (this.phoneNumber.length > 10) {
                        if (this.phoneNumber[0] == "1") {
                            this.phoneNumber = this.phoneNumber.substring(1, 11);
                        }
                    }

                    this.instaTouchIDPrefilled = true;
                    this.enableEditPersonalInfo = true;

                    this.visibleRightTab = "showEnterInformation";
                    this.scrollToTopOfPage();

                    this.isLoading = false;

                }).catch(error => {
                    this.skipInstaTouchID();
                    console.log(error);
                }).finally(function () {

                });
            },
            isNull(value) {
                return (value != null ? value : "");
            },
            headerEnrichmentMDNIdentificationIsComplete() {

                this.isLoading = true;

                creditDriverApi.postInstaTouchIDDetermineWorkflow({
                    sessionId: this.sessionId,
                    mobilePhoneNumber: this.submittedPhoneNumber,
                    mobileWorkFlow: this.mobileWorkFlow
                }).then(response => {

                    //if otpTransactionId is empty, then this is the mobile workflow, otherwise an OTP was sent to the candidate
                    if (response.data === "") {
                        this.submitConsentAndGetConsumerIdentity();
                    }
                    else if (response.data === "WiFi") {
                        this.isLoading = false;
                        this.visibleRightTab = "showSubmitPhoneNumberForOneTimePassword";
                        if (this.submittedPhoneNumber === "") {
                            this.enableEditSubmittedPhoneNumber = true;
                            this.$refs.refSubmittedPhoneNumber2.focus();
                        }
                        this.scrollToTopOfPage();
                    }
                    else { //Send an OTP to the candidate
                        this.isLoading = false;
                        this.visibleRightTab = "showSubmitPhoneNumberForOneTimePassword";
                        if (this.submittedPhoneNumber === "") {
                            this.enableEditSubmittedPhoneNumber = true;
                            this.$nextTick(function () {
                                this.$refs.refSubmittedPhoneNumber2.focus();
                            });
                        }
                        this.scrollToTopOfPage();
                    }

                }).catch(error => {
                    this.skipInstaTouchID();
                    console.log(error);
                }).finally(function () {

                });
            },
            submitPhoneAndName() {
                this.updateCandidatePhoneNumberFirstNameLastName();
                this.visibleRightTab = "showSubmitLast4SSN";
                this.scrollToTopOfPage();
            },
            submitLast4SSN() {
                this.updateCandidateZipCodeLast4SSN();
                this.headerEnrichmentMDNIdentificationIsComplete();

            },
            submitPhoneNumberForOneTimePassword() {

                if (!this.showEnterTheCode) {
                    this.wiFiWorkflowSendOTP();
                } else {
                    this.wiFiWorkflowValidateOTP();
                }

            },
            wiFiWorkflowSendOTP() {

                if (this.submittedPhoneNumber.startsWith("555")) {
                    this.skipInstaTouchID();
                    return;
                }

                this.isLoading = true;

                creditDriverApi.postInstaTouchIDWiFiWorkflowSendOTP({
                    sessionId: this.sessionId,
                    mobileNumber: this.submittedPhoneNumber
                }).then(response => {
                    if (response.data.transactionId === "error" || response.data.transactionId === "") {
                        //alert("wiFiWorkflowSendOTP error");
                        this.skipInstaTouchID();
                    }
                    else {
                        this.enableEditSubmittedPhoneNumber = false;
                        this.otpTransactionId = response.data.transactionId;
                        this.showEnterTheCode = true;
                        this.$nextTick(function () {
                            this.$refs.refOneTimePassword.focus();
                        });
                    }

                    this.isLoading = false;
                }).catch(error => {
                    this.skipInstaTouchID();
                    console.log(error);
                }).finally(function () {

                });
            },
            wiFiWorkflowValidateOTP() {

                this.isLoading = true;

                creditDriverApi.postInstaTouchIDWiFiWorkflowValidateOTP({
                    sessionId: this.sessionId,
                    otpTransactionId: this.otpTransactionId,
                    phoneNumber: this.submittedPhoneNumber,
                    passcode: this.oneTimePassword
                }).then(response => {
                    if (response.data === "success") {
                        this.submitConsentAndGetConsumerIdentity();
                    } else {
                        //alert("wiFiWorkflowValidateOTP error");
                        this.skipInstaTouchID();

                        this.isLoading = false;
                    }

                }).catch(error => {
                    console.log(error);
                }).finally(function () {

                });
            },
            pollForSecureMFAStatus() {
                var localMFASessionId = this.mfaSessionId;
                var localMobilePhoneNumber = this.phoneNumber;
                this.secureMFAValidateAttemptCount = 0;
                var that = this;

                this.secureMFATimerID = setTimeout(function () {
                    const mfaValidatePostData = {
                        efxSessionId: localMFASessionId,
                        mobilePhoneNumber: localMobilePhoneNumber
                    };

                    creditDriverApi.postGetSecureMFAStatus(mfaValidatePostData).then(response => {

                        that.secureMFAValidateAttemptCount++;

                        if (response.data == "Green" || response.data == "Yellow") {
                            that.secureMFAStatus = response.data;
                            that.submitCandidateInformation();
                        }
                        else if (response.data == "Orange" || response.data == "Red" || response.data == "") {
                            that.visibleRightTab = "showEnterInformation";
                            this.scrollToTopOfPage();
                        }
                        else if (response.data == "OP.B1011") {
                            if (that.secureMFAValidateAttemptCount < 12) {
                                that.pollForSecureMFAStatus();
                            }
                            else {
                                that.visibleRightTab = "showEnterInformation";
                                this.scrollToTopOfPage();
                            }
                        }

                    }).catch(error => {
                        alert(error);
                        console.log(error);
                    }).finally(function () {

                    });
                },
                    15000
                );
            },
            submitCandidateInformationForDIT() {

                this.isLoading = true;

                const postData = {
                    Request: {
                        sessionId: this.sessionId,
                        firstName: this.firstName,
                        lastName: this.lastName,
                        ssn: this.fullSSN,
                        dateOfBirth: this.dateOfBirthIso,
                        streetAddress: this.streetAddress,
                        city: this.city,
                        state: this.state,
                        zipCode: this.zipCode,
                        mobilePhoneNumber: this.phoneNumber,
                        email: this.email,
                        ioBB: document.getElementById('ioBB')?.value || "",
                        instaTouchIDPrefilled: this.instaTouchIDPrefilled
                    }
                };

                creditDriverApi.postSubmitCandidateInformationForDITandSecureMFA(JSON.stringify(postData)).then(response => {

                    this.mfaSessionId = response.data.sessionId;

                    this.visibleRightTab = "showCheckSecureMFA";
                    this.scrollToTopOfPage();

                    this.secureMFAValidateAttemptCount = 0;
                    this.pollForSecureMFAStatus();

                    this.isLoading = false;

                }).catch(error => {
                    alert(error);
                    console.log(error);
                }).finally(function () {

                });
            },
            submitCandidateInformation() {

                if (this.secureMFAStatus == "" && !this.instaTouchIDPrefilled) {
                    this.submitCandidateInformationForDIT();
                    return;
                }

                this.isLoading = true;

                const postData = {
                    Request: {
                        sessionId: this.sessionId,
                        firstName: this.firstName,
                        lastName: this.lastName,
                        ssn: this.fullSSN,
                        dateOfBirth: this.dateOfBirthIso,
                        streetAddress: this.streetAddress,
                        city: this.city,
                        state: this.state,
                        zipCode: this.zipCode,
                        mobilePhoneNumber: this.phoneNumber,
                        email: this.email,
                        ioBB: document.getElementById('ioBB').value,
                        instaTouchIDPrefilled: this.instaTouchIDPrefilled
                    }
                };

                creditDriverApi.postSubmitCandidateInformationForCreditCheck(JSON.stringify(postData)).then(response => {
                    this.candidateId = response.data.candidateId;
                    this.creditScore = response.data.creditScore;
                    this.autoLines = response.data.autoLines;

                    this.visibleRightTab = "showCreditReport";

                    this.isLoading = false;

                    this.showDashboard = true;
                    this.scrollToTopOfPage();

                }).catch(error => {
                    alert(error);
                    console.log(error);
                }).finally(function () {

                });
            },
            scrollToTopOfPage() {
                if ('scrollRestoration' in history) {
                    history.scrollRestoration = 'manual';
                }
                window.scrollTo(0, 0);
            },
            skipInstaTouchID() {
                let configScript = document.createElement('script');
                configScript.setAttribute('src', require('../js/config.js'));
                document.head.appendChild(configScript);

                let loaderScript = document.createElement('script');
                loaderScript.setAttribute('src', require('../js/loader.js'));
                document.head.appendChild(loaderScript);

                this.isLoading = false;
                this.enableEditPersonalInfo = true;
                this.firstName = this.submittedFirstName;
                this.lastName = this.submittedLastName;
                this.phoneNumber = this.submittedPhoneNumber;
                this.enableEditAddressInfo = true;
                this.visibleRightTab = "showEnterInformation";
                this.scrollToTopOfPage();
            },
            playModalHelpVideo() {
                var modal = document.getElementById("myModal");
                modal.style.display = "block";
                var video = document.getElementById("helpVideoPlayer");
                video.play();
            },
            playHelpVideoMain() {
                var video = document.getElementById("helpVideoPlayerMain");
                video.play();
                this.isPlayingMainVideo = true;
            },
            getCook(cookiename) {
                // Get name followed by anything except a semicolon
                var cookiestring = RegExp(cookiename + "=[^;]+").exec(document.cookie);
                // Return everything after the equal sign, or an empty string if the cookie name not found
                return decodeURIComponent(cookiestring != null ? cookiestring.toString().replace(/^[^=]+./, "") : "");
            }
        },
        created() {
            this.mobileWorkFlow = true;
        },
        mounted() {
            // Get the modal
            var modal = document.getElementById("myModal");

            // Get the <span> element that closes the modal
            var span = document.getElementsByClassName("close")[0];

            // When the user clicks on <span> (x), close the modal
            span.onclick = function () {
                modal.style.display = "none";
            }

            // When the user clicks anywhere outside of the modal, close it
            window.onclick = function (event) {
                if (event.target == modal) {
                    var video = document.getElementById("helpVideoPlayer");
                    video.pause();
                    video.currentTime = 0;
                    modal.style.display = "none";
                }
            }

            //Get optional query string params
            const urlParams = new URLSearchParams(location.search);

            if (urlParams.has("customerId")) {
                this.dsgssCustomerId = urlParams.get("customerId");
            }
            else {
                this.dsgssCustomerId = 0;
            }

            if (urlParams.has("clientSource")) {
                this.clientSource = urlParams.get("clientSource");
            }
            else {
                this.clientSource = "unknown";
            }

            if (urlParams.has("phone")) {
                this.prefillPhoneNumber = urlParams.get("phone");
            }

            if (this.$route.params.dealership == "profile") {
                this.candidateGuid = this.$route.params.qrcode;
                this.goToProfile();
            } else {
                this.getCarrierUrl();
            }
        },
        directives: { mask },
        components: {
            Loading,
            CandidateDashboard
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    @import '../css/style.css';
    @import '../css/responsive.css';

    h3 {
        margin: 40px 0 0;
    }

    ul {
        list-style-type: none;
        padding: 0;
    }

    li {
        display: inline-block;
        margin: 0 10px;
    }

    a {
        color: #42b983;
    }

    /* The Modal (background) */
    .modal {
        display: none; /* Hidden by default */
        position: fixed; /* Stay in place */
        z-index: 1; /* Sit on top */
        left: 0;
        top: 0;
        width: 100%; /* Full width */
        height: 100%; /* Full height */
        overflow: auto; /* Enable scroll if needed */
        background-color: rgb(0,0,0); /* Fallback color */
        background-color: rgba(0,0,0,0.4); /* Black w/ opacity */
    }

    /* Modal Content/Box */
    .modal-content {
        background-color: #fefefe;
        margin: 15% auto; /* 15% from the top and centered */
        padding: 0px;
        border: 1px solid #888;
        width: 80%; /* Could be more or less, depending on screen size */
    }

    /* The Close Button */
    .close {
        color: #aaa;
        position: absolute;
        font-size: 28px;
        font-weight: bold;
    }

        .close:hover,
        .close:focus {
            color: black;
            text-decoration: none;
            cursor: pointer;
        }

    /* Mobile logo container - visible on mobile, hidden on desktop */
    .mobile-logo-container {
        width: 100%;
        text-align: center;
        padding: 15px 0;
        margin: 0 auto;
        display: none;
    }

    /* Show on mobile devices (screens smaller than 768px) */
    @media (max-width: 767px) {
        .mobile-logo-container {
            display: block;
        }
    }
</style>
